<ul class="nav nav-tabs">

  @if (('article.change'|HasPerm)) {
    <li role="presentation" [ngClass]="{active: state.is('article_config.extra')}">
      <a uiSref="article_config.extra">Liefervorschriften</a>
    </li>
  }

  @if (('article.configuration'|HasPerm)) {
    <li role="presentation" [ngClass]="{active: state.is('article_config.main')}">
      <a uiSref="article_config.main">Konfiguration</a>
    </li>
  }

  @if (('article.mask'|HasPerm)) {
    <li role="presentation" [ngClass]="{active: state.is('article_config.release')}">
      <a uiSref="article_config.release">Freigabemasken</a>
    </li>
  }

  @if (('article.production_step_setting'|HasPerm)) {
    <li role="presentation" [ngClass]="{active: state.is('article_config.production_step')}"
      >
      <a uiSref="article_config.production_step">Fertigungsschritte</a>
    </li>
  }

  @if (('production.template_setting'|HasPerm)) {
    <li role="presentation" [ngClass]="{active: state.is('article_config.production_template')}"
      >
      <a uiSref="article_config.production_template">Fertigungsvorlage</a>
    </li>
  }

  @if (('article.delete'|HasPerm)) {
    <li role="presentation" [ngClass]="{active: state.is('article_config.delete')}">
      <a uiSref="article_config.delete">Artikel löschen</a>
    </li>
  }

  @if (('article.lock'|HasPerm)) {
    <li role="presentation" [ngClass]="{active: state.is('article_config.lock')}">
      <a uiSref="article_config.lock">Artikel sperren</a>
    </li>
  }

  @if (('article.lock'|HasPerm)) {
    <li role="presentation" [ngClass]="{active: state.is('article_config.unlock')}">
      <a uiSref="article_config.unlock">Artikel entsperren</a>
    </li>
  }

  @if (('article.customer_locker'|HasPerm)) {
    <li role="presentation"
      [ngClass]="{active: state.is('article_config.customer_locker')}"
      >
      <a uiSref="article_config.customer_locker">Kunden Artikel sperren</a>
    </li>
  }

  @if (('article.configuration'|HasPerm)) {
    <li role="presentation" [ngClass]="{active: state.is('article_config.weight_calculation')}">
      <a uiSref="article_config.weight_calculation">LP Gewichtsberechnung</a>
    </li>
  }

  @if (('article.mask'|HasPerm)) {
    <li role="presentation" [ngClass]="{active: state.is('article_config.field_names')}">
      <a uiSref="article_config.field_names">Artikel Felder Bezeichnung</a>
    </li>
  }
</ul>
